import React from 'react';
import '../background.css';

const SpaceBackground = () => {
  return (
    <>
      <div className="star1" />
      <div className="star2" />
      <div className="star2b" />
      <div className="star2c" />
      <div className="star3" />
      <div className="star3b" />
      <div className="star3c" />
      <div className="star4" />
      <div className="star4b" />
      <div className="star4c" />
      <div className="star4d" />
      <div className="star4e" />
      <div className="star4f" />
      <div className="star4g" />
      <div className="star4h" />
    </>
  )
}

export default SpaceBackground;